<template>
  <div v-if="isActive" class="popup__container popup--darkscreen">
    <div class="popup--bg" :class="backgroundClass">
      <div class="popup__header">
        <slot name="header">
          <h3>{{ title }}</h3>
        </slot>
      </div>
      <div class="popup__body">
        <!-- Modal Content -->
        <slot name="body">
          <button @click="close" type="button" class="button">Close</button>
        </slot>
        <!-- Modal footer -->
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  isActive: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'sm'
  }
})
// define emits
const emit = defineEmits(['close'])
// define computed props
const backgroundClass = computed(() => {
  let cssClass = ''
  switch (props.size) {
    case 'lg':
      cssClass = 'popup--bg-lg'
      break
    case 'md':
      cssClass = 'popup--bg-md'
      break
    default:
      cssClass = ''
      break
  }
  
  return cssClass
})
// define methods
const close = () => {
  emit('close')
}
</script>

<style lang="scss" scoped>
.popup__container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;

  h2 {
    margin: initial;
  }

  ul {
    list-style-type: none;
    padding-inline-start: 0;
    margin-left: 0;
  }
}
.popup--darkscreen {
  background: #00000080;
}

.popup--bg {
  overflow: auto;
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  padding: 0 12px 24px;
  border-radius: 3px;
  border-bottom-left-radius: 20px;
  background: #fff;

  &-md {
    max-width: 50%;
  }

  &-lg {
    max-width: 70%;
  }
}

.popup__header {
  position: sticky;
  top: 0;
  background: #fff;
  margin: 0 0 12px;
  padding: 24px 24px 0;
  z-index: 99999 !important;

  & > h1, h2, h3, h4, h5, h6 {
    display: inline-block;
    padding-bottom: 10px;
    border-bottom: solid 3px #0c3354;
  }
}

.popup__body {
  width: 100%;
  overflow: auto;
  padding: 0 36px;
}
</style>